'use client';

import { useEffect, useState } from 'react';

/**
 * Self-contained Navhaus signature component.
 * Copy-paste this entire file to any React/Next.js project.
 * Font is lazy-loaded to avoid blocking critical path.
 */
export function NavhausSignature() {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    const loadFont = () => {
      // Check if already loaded
      if (document.querySelector('link[href*="Barlow"]')) {
        setFontLoaded(true);
        return;
      }

      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Barlow:wght@700&display=swap';
      link.rel = 'stylesheet';
      link.onload = () => setFontLoaded(true);
      document.head.appendChild(link);
    };

    // Load font during idle time, or after 100ms fallback
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadFont, { timeout: 2000 });
    } else {
      setTimeout(loadFont, 100);
    }
  }, []);

  return (
    <a
      href="https://navhaus.com"
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-2 text-sm text-foreground/60 hover:text-primary transition-colors"
    >
      <span
        style={{
          fontFamily: fontLoaded ? "'Barlow', sans-serif" : 'system-ui, sans-serif',
          fontWeight: 700,
          color: '#0f1729',
          fontSize: '16px',
        }}
      >
        Built by Navhaus
      </span>
      <span className="inline-flex gap-2 mt-0.5">
        <span
          className="inline-block w-2 h-2 rounded-full transition-transform duration-600 group-hover:animate-[bounce_0.6s_ease-in-out]"
          style={{ backgroundColor: '#e94436' }}
        ></span>
        <span
          className="inline-block w-2 h-2 rounded-full transition-transform duration-600 group-hover:animate-[bounce_0.6s_ease-in-out_0.1s]"
          style={{ backgroundColor: '#ffc527' }}
        ></span>
        <span
          className="inline-block w-2 h-2 rounded-full transition-transform duration-600 group-hover:animate-[bounce_0.6s_ease-in-out_0.2s]"
          style={{ backgroundColor: '#434897' }}
        ></span>
      </span>
    </a>
  );
}
